<template>
    <div>
        <div class="row justify-content-center">
            <div class="card p-3 col-12 col-lg-8">
                <div class="card-header text-center my-3">Join a Room!</div>
                <div>
                    <label>Room ID:</label><input v-model="roomId" @keypress.enter="enter()" type="text" class="form-control">
                    <label>User ID:</label><input v-model="userId" @keypress.enter="enter()" type="text" class="form-control">
                    <div class="row justify-content-center my-3">
                        <button @click="enter()" class="btn btn-primary col-4">Enter</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['loginParams'],
    data(){
        return {
            roomId: '',
            userId: '',
            newRoom: false,
        }
    },
    methods:{
        enter(){
            let roomId = this.roomId.trim();
            let userId = this.userId.trim();
            if(roomId.length == 0 || userId.length == 0){
                this.roomId = '';
                this.userId = '';
                alert('Room ID and User ID are required.');
                return;
            }
            this.$emit('login', { roomId: this.roomId, userId: this.userId });
            this.$router.push({
                name: 'XORoom',
                params: {
                    roomId: this.roomId,
                    userId: this.userId,
                },
            });
        }
    },
    created(){
        if(this.loginParams.roomId) this.roomId = this.loginParams.roomId;
        if(this.loginParams.userId) this.userId = this.loginParams.userId;
    }
}
</script>
